/**
 * An external state owner's contribution to a finder bar's menu. It owns no chip
 * or form value; its actions close over the owner's implementation.
 *
 * @typedef {object} FinderContribution
 * @property {string} id - unique among contributions to this bar.
 * @property {string} label
 * @property {string} [icon]
 * @property {FinderContributionState} state
 * @property {{clear: () => void, reveal?: () => void}} actions
 */

/**
 * @typedef {object} FinderContributionState
 * @property {boolean} active - a normalized criterion is applied, including restored state.
 * @property {boolean} withheld - omit this contribution from the menu and count.
 * @property {boolean} clearable - the owner permits clearing. The menu offers and invokes clear
 * only for active, non-withheld entries; this permission can remain true while inactive.
 */

/**
 * @typedef {object} FinderContributionConnection
 * @property {boolean} closed - read-only; also true after replacement or bar unmount.
 * @property {(state: FinderContributionState) => void} updateState - a full snapshot.
 * @property {() => void} disconnect - idempotent; retired handles cannot affect replacements.
 */

export const CONTRIBUTION_REFERENCE_ATTRIBUTE = "contribution-ref";
